
import './App.css';
import { AppHeader } from './Components/AppHeader/AppHeader';
import Routes from './Routes'
function App() {
  return (
    <div className="App">
      <AppHeader/>
      <Routes/>
    </div>
  );
}

export default App;
